"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Lookup Data Record',
    description: 'Find a one data record by its fields',
});
//# sourceMappingURL=lookup-data-record.js.map